import { gql } from 'graphql-request'

export const QueryHubspotForm = gql`
  fragment FragmentHubspotForm on HubSpotFormModelRecord {
    id
    __typename
    formId
    portalId
    productPageRedirect
    jsScript
    countryRedirect
  }
`